import app from "flarum/forum/app";
import { extend, override } from "flarum/extend";
import Application from "flarum/common/Application";
import NotificationList from "flarum/forum/components/NotificationList";
import CommentPost from "flarum/forum/components/CommentPost";
import Button from "flarum/common/components/Button";
import UserPage from "flarum/components/UserPage";

app.initializers.add("lltq-core-changes", (app) => {
  // custom error message
  override(Application.prototype, "requestErrorCatch", function (
    original,
    error,
    customHandler
  ) {
    if (app.forum.attribute("show_custom_botcheck_message")) {
      const formattedErrors =
        error.response?.errors?.map((e) => decodeURI(e.detail ?? "")) ?? [];

      const deleteCookie = (name) => {
        document.cookie =
          name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
      };

      const redirected = error.options?.url !== error.xhr?.responseURL;

      if (
        error.xhr?.status === 200 &&
        redirected &&
        error.xhr?.responseURL?.endsWith("/challenge")
      ) {
        error.alert = {
          type: "error",
          content: "Сработала зашита, нужно пройти проверку",
          /*controls: [
            <Button className="Button Button--link" onclick={() => window.location.reload()}>
              Обновить
            </Button>,
          ],*/
        };

        if (customHandler) {
          customHandler(error);
        } else {
          this.requestErrorDefaultHandler(error, false, formattedErrors);
        }

        deleteCookie("fiNsJitDX28FDHsiCNeim4hnco8G1n");
        window.location = "/challenge";

        return Promise.reject(error);
      } else {
        return original(error, customHandler);
      }
    } else {
      return original(error, customHandler);
    }
  });

  // fixing notifications infinite scroll (mobile firefox problem)
  override(NotificationList.prototype, "scrollHandler", function (original) {
    const state = this.attrs.state;

    // Whole-page scroll events are listened to on `window`, but we need to get the actual
    // scrollHeight, scrollTop, and clientHeight from the document element.
    const scrollParent = this.inPanel()
      ? this.$scrollParent[0]
      : document.documentElement;

    // On very short screens, the scrollHeight + scrollTop might not reach the clientHeight
    // by a fraction of a pixel, so we compensate for that.
    // NOTE: fix was applied here (<= 1 => <= 100) because it appears that mobile ff never reaches that low value
    const atBottom =
      Math.abs(
        scrollParent.scrollHeight -
          scrollParent.scrollTop -
          scrollParent.clientHeight
      ) <= 100;

    if (state.hasNext() && !state.isLoadingNext() && atBottom) {
      state.loadNext();
    }
  });

  override(CommentPost.prototype, "oncreate", function (original, vnode) {
    original(vnode);

    if (app.forum.attribute("override_links")) {
      this.$(".Post-body a").each(function () {
        if (
          this.pathname.startsWith("/u/") ||
          this.pathname.startsWith("/d/")
        ) {
          const replaceText = this.innerText == this.href;
          this.href = this.pathname + this.search;
          if (replaceText) this.innerText = this.pathname;
        }
      });
    }
  });

  // so that "back" button would properly navigate inside and after opening userpage
  extend(UserPage.prototype, "oninit", function () {
    if (app.forum.attribute("override_back_button")) {
      app.history.push(app.current.get("routeName"));
    }
  });
});
